import styled from 'react-emotion';

import {inputStyles} from 'app/styles/input';

const TextArea = styled.textarea`
  ${inputStyles};
`;
export default TextArea;



// WEBPACK FOOTER //
// ./app/views/settings/components/forms/controls/textarea.jsx